export const CALL_RESULTS_LOGIC_ROLE = Object.freeze({
  CORRECT_CONTACT: 'ACTIVITY__CALL_RESULT__CORRECT_CONTACT',
  APPROACH: 'ACTIVITY__CALL_RESULT__APPROACH',
  GATEKEEPER: 'ACTIVITY__CALL_RESULT__GATEKEEPER',
  NO_ANSWER: 'ACTIVITY__CALL_RESULT__NO_ANSWER',
  WRONG_DATA: 'ACTIVITY__CALL_RESULT__WRONG_DATA',
});
